import { useState } from "react";
import { auth } from "../../../services/firebase";

// Consuming router state must not release an in-flight question's ownership.
// Each callback retains its original owner, even if a later render drops it.
export function useHandedQuestionOwnership<Question>(
  initialOwnerUid: string | null,
  initialQuestion: Question | null
) {
  const [held, setHeld] = useState({
    ownerUid: initialOwnerUid,
    question: initialQuestion,
  });
  return {
    ownerUid: held.ownerUid,
    question: held.question,
    isOwner: () =>
      held.ownerUid === null ||
      (auth.currentUser !== null && auth.currentUser.uid === held.ownerUid),
    discard: () => {
      setHeld({ ownerUid: null, question: null });
    },
  };
}
